import { CircleAlert, CircleCheck, CircleX } from 'lucide-react';
import React from 'react';
export default function ValidationIcon(props) {
    switch (props.validationType) {
        case 'correct':
            return React.createElement(CircleCheck, { className: `f-color-valid rounded-full ml-1 mt-2 ${props.className}`, size: props.size || 25 });
        case 'retry':
            return React.createElement(CircleX, { className: `f-color-invalid rounded-full ml-1 mt-2 ${props.className}`, size: props.size || 25 });
        case 'confirm':
            return React.createElement(CircleAlert, { className: `f-color-warning rounded-full ml-1 mt-2 ${props.className}`, size: props.size || 25 });
        case 'missing-part':
            return React.createElement(CircleAlert, { className: `f-color-warning rounded-full ml-1 mt-2 ${props.className}`, size: props.size || 25 });
        default:
            return React.createElement("span", { className: `bg-gray-300 inline-block rounded-full ml-1 mt-2 ${props.className}`, style: { width: props.size - 2 || 25, height: props.size - 2 || 25 } });
    }
}
